/* ACYFRQ Dual Care v6: native Shopify forms; no cart interception or fabricated data. */
(() => {
  'use strict';
  const moneyText = value => {
    const node = document.createElement('span');
    node.innerHTML = String(value == null ? '' : value);
    return node.textContent || '';
  };
  function init(scope = document) {
    scope.querySelectorAll('[data-menu-toggle]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = '1';
      button.addEventListener('click', () => {
        const menu = document.getElementById(button.getAttribute('aria-controls'));
        if (!menu) return;
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open)); menu.hidden = !open;
      });
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      if (menu) {
        menu.addEventListener('click', event => { if (event.target.closest('a')) { menu.hidden = true; button.setAttribute('aria-expanded', 'false'); } });
        menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.hidden = true; button.setAttribute('aria-expanded', 'false'); button.focus(); } });
      }
    });
    scope.querySelectorAll('[data-localize-select]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = '1';
      select.addEventListener('change', () => {
        if (select.form) select.form.requestSubmit();
      });
    });
    scope.querySelectorAll('[data-product-root]').forEach(root => {
      if (root.dataset.ready) return;
      let variants;
      try { variants = JSON.parse(root.querySelector('[data-variants-json]').textContent); }
      catch (_) { return; }
      const select = root.querySelector('[data-variant-select]');
      if (!select || !Array.isArray(variants)) return;
      root.dataset.ready = '1';
      const image = root.querySelector('[data-main-image] img');
      const tiles = root.querySelector('[data-variant-tiles]');
      const addButton = root.querySelector('[data-add-button]');
      const sticky = root.querySelector('[data-sticky-buy]');
      function setImage(src, alt) {
        if (!image || !src) return;
        image.removeAttribute('srcset'); image.src = src; image.alt = alt || '';
        root.querySelectorAll('[data-thumb]').forEach(thumb => {
          const active = thumb.dataset.src === src;
          thumb.classList.toggle('is-active', active); thumb.setAttribute('aria-pressed', String(active));
        });
      }
      function applyVariant(updateUrl) {
        const variant = variants.find(v => String(v.id) === String(select.value));
        if (!variant) return;
        root.querySelectorAll('[data-price], [data-sticky-price]').forEach(el => { el.textContent = moneyText(variant.price); });
        const compare = root.querySelector('[data-compare]');
        if (compare) { compare.textContent = moneyText(variant.compare); compare.hidden = !variant.compare; }
        root.querySelectorAll('[data-add-button], [data-sticky-add]').forEach(el => { el.disabled = !variant.available; });
        root.querySelectorAll('[data-add-text], [data-sticky-label]').forEach(el => { el.textContent = variant.available ? root.dataset.addLabel : root.dataset.soldLabel; });
        const payment = root.querySelector('[data-payment-wrap]');
        if (payment) payment.hidden = !variant.available;
        const quantity = root.querySelector('input[name="quantity"]');
        if (quantity) {
          const min = Number(variant.min) || 1, step = Number(variant.step) || 1;
          quantity.min = String(min); quantity.step = String(step);
          if (variant.max != null) quantity.max = String(variant.max); else quantity.removeAttribute('max');
          if (updateUrl) quantity.value = String(min);
        }
        root.querySelectorAll('[data-variant-id]').forEach(el => {
          const active = el.dataset.variantId === String(variant.id);
          el.classList.toggle('is-selected', active); el.setAttribute('aria-pressed', String(active));
        });
        setImage(variant.image, variant.alt);
        if (updateUrl) {
          const url = new URL(window.location.href); url.searchParams.set('variant', String(variant.id));
          history.replaceState(history.state, '', url);
        }
      }
      if (tiles && select.tagName === 'SELECT' && variants.length <= 12) {
        variants.forEach(variant => {
          const button = document.createElement('button'); button.type = 'button';
          button.className = 'variant-tile'; button.dataset.variantId = String(variant.id);
          const title = document.createElement('strong'); title.textContent = variant.title;
          const price = document.createElement('span'); price.textContent = moneyText(variant.price) + (variant.available ? '' : ' · ' + root.dataset.soldLabel);
          button.append(title, price);
          button.addEventListener('click', () => { select.value = String(variant.id); select.dispatchEvent(new Event('change', { bubbles: true })); });
          tiles.appendChild(button);
        });
        tiles.hidden = false; select.classList.add('visually-hidden'); select.tabIndex = -1;
      }
      select.addEventListener('change', () => applyVariant(true));
      root.querySelectorAll('[data-thumb]').forEach(thumb => thumb.addEventListener('click', () => setImage(thumb.dataset.src, thumb.dataset.alt)));
      applyVariant(false);
      if (sticky && addButton) {
        let queued = false;
        const updateSticky = () => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(() => {
            sticky.hidden = addButton.getBoundingClientRect().bottom >= 0;
            queued = false;
          });
        };
        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', updateSticky, { passive: true });
        root._acyStickyHandler = updateSticky;
        updateSticky();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-product-root]').forEach(root => { if (root._acyStickyHandler) { window.removeEventListener('scroll', root._acyStickyHandler); window.removeEventListener('resize', root._acyStickyHandler); } });
  });
})();
